<template>
  <b-container class="search-area" fluid="lg">
    <div class="mb-3">
      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Template name</h3>
          <input
            v-model="conditions.tutorNameOrId"
            type="text"
            class="search-tutor"
          >
        </b-col>
        <b-col>
          <h3 class="common__search-title">Month</h3>
          <select class="form-control w-50">
            <option></option>
            <option>1</option>
            <option>2</option>
            <option>3</option>
            <option>4</option>
            <option>5</option>
            <option>6</option>
            <option>7</option>
            <option>8</option>
            <option>9</option>
            <option>10</option>
            <option>11</option>
            <option>12</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Mail Template</h3>
          <select class="form-control w-50">
            <option></option>
            <option>aaaaa</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Subject</h3>
          <div class="ml-4">mail information</div>
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Mail text</h3>
          <div class="ml-4">mail Text</div>
        </b-col>
      </b-form-row>
    </div>
  </b-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import PositionsInput from '@/components/parts/inputItem/PositionsInput.vue';
import GendersInput from '@/components/parts/inputItem/GendersInput.vue';
import NationalityInput from '@/components/parts/inputItem/NationalityInput.vue';
import _ from 'lodash';
import { Nationality, Position } from '@/store/master/types';
import { genderCode } from '@/store/common.types';

export interface TutorSearchConditions {
  tutorNameOrId: string|null
  positions: Position[]
  isIncludeTerminationOfService: boolean
  genders: genderCode[]
  nationality: Nationality|null
}

@Component({
  components: {
    PositionsInput,
    GendersInput,
    NationalityInput,
  },
})
export default class TutorSearch extends Vue {
  private conditions: TutorSearchConditions = {
    tutorNameOrId: null,
    positions: [],
    isIncludeTerminationOfService: false,
    genders: [],
    nationality: null,
  }

  search() {
    this.$emit('search', this.conditions)
  }

  reset() {
    this.conditions = {
      tutorNameOrId: null,
      positions: [],
      isIncludeTerminationOfService: false,
      genders: [],
      nationality: null,
    }
    this.search()
  }
}
</script>

<style scoped>
input[type="text"], select{
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 200px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

input[type="checkbox"] {
  margin-right:8px;
  vertical-align: middle;
}

.search-tutor {
  width:200px;
}
</style>
